import { Box } from '@mui/material';
import React from 'react';
import PlanSelectionCards from '../../plans/components/PlanSelectionCards';

interface PlanSelectionStepProps {
    onSelectDiy: () => void;
    onSelectExpert: () => void;
    onNext: () => void;
    isDiyLoading?: boolean;
}

const PlanSelectionStep: React.FC<PlanSelectionStepProps> = ({
    onSelectDiy,
    onSelectExpert,
    onNext,
    isDiyLoading = false
}) => {
    const handleSelectDiy = () => {
        onSelectDiy();
        // Don't call onNext() - the parent handler manages the flow
    };

    const handleSelectExpert = () => {
        onSelectExpert();
        // Don't call onNext() - the parent handler manages the flow
    };

    return (
        <Box 
            sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                flex: 1,
                justifyContent: 'center',
                minHeight: '400px'
            }}
        >
            <PlanSelectionCards
                onSelectDiy={handleSelectDiy}
                onSelectExpert={handleSelectExpert}
                expertDisabled={false}
                isDiyLoading={isDiyLoading}
            />
        </Box>
    );
};

export default PlanSelectionStep;